import React, { useState, useEffect, } from 'react';
import { useDispatch } from 'react-redux';
import { setOpenLoader, setTitleLoader } from '../../../../config/redux/actions';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import CustomSelect from '../../../components/General/CustomSelect';
import CustomInput from '../../../components/General/CustomInput';
import _ from 'lodash';
import { simpleAlerts } from '../../../../utils/alerts';
import { validationMessages } from '../../../../message/validations';
import BodyCategoryCondition from '../../../components/Definitions/Concepts/Category/BodyCategoryCondition';

const ConditionCategory = (props) => {
    const { states, data, setData, getInfo, dataConditions,valueCondition, setValueCondition } = props;
    const dispatch = useDispatch();
    const handleOpenLoader = (value) => dispatch(setOpenLoader(value));
    const handleTitleLoader = (value) => dispatch(setTitleLoader(value));

    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState([]);
  
    const handleSearch = (search) => {
        setSearch(search);
        const filtered = data.filter(item =>
            item.desCategoTipoCondic.toLowerCase().includes(search.toLowerCase())
        );
        setFilteredData(filtered);
    };
 
    const newInfo = {
        desCategoTipoCondic: null,
        tipoCondicInsegu_id: valueCondition,
        estado_id: 1,
        edit: 1,
    }
    
    const addCategoryByTypeCondition = () => {
        if (valueCondition <= 0) {
             simpleAlerts({ message: validationMessages.add_category_condition });
            return; 
        }
        let updData = _.cloneDeep(data);
        updData?.push(newInfo);
        return setData(updData);
    }

    return (
        <div>
            <h1 className='text-center title-page'>Def. Categoria - Tipo Condición</h1>
            <div className='row justify-content-center'>
                <div className='col-md-2'>
                    <CustomInput
                        title={'Buscar'}
                        placeholder={'Buscar categorias condiciones'}
                        value={search}
                        onChange={(e) => handleSearch(e.target.value)}
                    />
                </div>
                <div className='col-md-3'>
                    <CustomSelect
                        title={'Condicion'}
                        placeholder={'Selecionar condicion'}
                        options={dataConditions}
                        value={valueCondition || 0}
                        onChange={(value, event) => setValueCondition(value)}
                    />
                </div>
                <div className='col-md-1 d-flex justify-content-evenly align-items-end'>
                    <button className='btn btn-sm btn-primary' onClick={addCategoryByTypeCondition}><AddCircleIcon fontSize='small' /> Agregar</button>
                </div>
            </div>
            <div className='row justify-content-center mt-3'>
                <div className='col-md-7 col-sm-10'>
                    <BodyCategoryCondition 
                         states={states}
                         getInfo={getInfo}
                         data={filteredData.length > 0 ? filteredData : data}
                         setData={setData}
                         id={"id_categoTipoCondic"}
                    
                    />
                </div>
            </div>
        </div>
    )
}

export default ConditionCategory